<template>
  <div class="col-md-12">
    <div id="top-bar" class="row">
      <div class="col-md-4 text-left">{{ versionName }}</div>
      <div class="col-md-4 text-center"><save-text></save-text></div>
      <div v-show="showPreviewLink" class="col-md-4 text-right">
        <button
          @click="openPreview"
          :class="['btn-link', { disabled: hasUnsavedEdits }]"
          :disabled="hasUnsavedEdits"
        >
          <strong
            ><span class="fas fa-external-link-square-alt mr-5"></span>
            <small>Preview Experience</small></strong
          >
        </button>
      </div>
    </div>
    <div class="row" v-if="isReady">
      <sidebar class="col-sm-3 col-md-2 full-height-builder"></sidebar>
      <div class="col-sm-9 col-md-10 full-height-builder pages-container">
        <transition name="fade" mode="out-in">
          <router-view :versionKey="parseInt(versionKey)"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import Sidebar from './Sidebar';
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
  export default {
    name: 'Edit',

    components: {
      Sidebar,
    },

    data() {
      return {
        isReady: false,
      };
    },

    async created() {
      await this.getVersionData({ versionKey: this.versionKey });
      await this.getMilestonesForAuthor({ authorKey: this.actorKey });
      await this.getAllVersions();

      this.SET_EDIT_MODE(true);
      this.isReady = true;
    },

    methods: {
      ...mapActions(['SET_MILESTONE']),
      ...mapActions('editMode', ['getVersionData']),
      ...mapActions('versions', ['getAllVersions']),
      ...mapActions(['getMilestonesForAuthor']),

      ...mapMutations(['SET_EDIT_MODE']),

      openPreview() {
        if (this.hasUnsavedEdits) return;

        this.SET_MILESTONE({
          message: 'Preview Your Inbox',
          tooltipDesc: this.tooltips.milestones['10'],
          timeout: 8000,
          milestoneKey: 10,
        });
        window.open('/capsiminbox/authoring-platform/preview', '_blank');
      },
    },

    computed: {
      ...mapGetters('editMode', ['hasUnsavedEdits']),
      ...mapState('editMode/version', ['versionName']),
      ...mapState('user', ['actorKey']),

      versionKey() {
        return parseInt(this.$route.params.resourceKey);
      },
      showPreviewLink() {
        return this.$route.name === 'inbox';
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media print {
    .pages-container {
      overflow: auto !important;
      width: 100% !important;
    }
    #top-bar {
      display: none;
    }
  }
  .pages-container {
    overflow-y: auto;
  }

  #top-bar {
    line-height: 45px;
    background: #f8f8f8;

    .btn-link {
      line-height: 1.7rem;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
</style>
